import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import {
    makeStyles,
    RadioGroup,
    Theme,
    Typography
} from '@material-ui/core'
import React from 'react'
import RadioButton from './RadioButton'

const useStyles = makeStyles((theme: Theme) => ({

    dialogContent: {
        padding: theme.spacing(3, 3, 2),
    },
    description: {
        fontSize: pxToRem(16),
        color: '#4D4D4D',
        marginBottom: theme.spacing(2),
        lineHeight: 1.5,
    },
    questionText: {
        fontSize: pxToRem(16),
        color: '#4D4D4D',
        marginBottom: theme.spacing(2),
    },
    radioGroup: {
        marginLeft: theme.spacing(1),
    },

}))

/**
 * Props for the ManageUnmappedProductDialog component
 */
export type ManageUnmappedProductDialogProps = { selectedOption: string, setSelectedOption: (value: string) => void }
/**
 * Initial step dialog for managing unmapped products.
 * 
 * Presents the user with two options:
 * 1. Add the product to an existing MasterSpec family
 * 2. Create a new family for the product
 * 
 * @param props - The component props
 * @returns The ManageUnmappedProductDialog component
 */
const ManageUnmappedProductDialog = ({ selectedOption, setSelectedOption }: ManageUnmappedProductDialogProps) => {
    const classes = useStyles()

    const handleRadioChange = React.useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedOption(event.target.value)
    }, [setSelectedOption])


    return (<>
        <Typography className={classes.description}>
            This product cannot be added to a project until it is
            included in a Family.
        </Typography>
        <Typography className={classes.questionText}>
            How do you want to proceed?
        </Typography>
        <RadioGroup
            value={selectedOption}
            onChange={handleRadioChange}
            className={classes.radioGroup}
        >
            <RadioButton
                value="existing"
                label="Add this product listing to an existing family"
            />
            <RadioButton
                value="new"
                label="Create a new family for this product listing" 
            />
        </RadioGroup></>
    )
}

export default ManageUnmappedProductDialog